import React from 'react'

import { NavLink } from 'react-router-dom'

import { SiteContext } from 'context/site-context'

import Pagination from 'components/atoms/Pagination'
import Select from 'components/atoms/Select'

import './index.scss'

import STATES_OPTIONS from './states_options'

const getThreeDigits = digit => {
  return digit < 10 ? `00${digit}`.toString() :
    digit < 100 ? `0${digit}`.toString() :
    digit.toString()
}

const scrollToTop = () => {
  try {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  } catch (e) {
    if (e instanceof TypeError) {
      window.scroll(0, 0)
    } else {}
  }
}

const DirectoryContent = ({ page = 1, st }) => {
  const [ site, setSite ] = React.useContext(SiteContext)

  const [ state, setState ] = React.useState({
    page: parseInt(page),
    perPage: 0,
    totalCount: 0,
    cities: [],
  })

  React.useEffect( () => {
    const filename = st ? `${st}/${getThreeDigits(state.page)}.json` : `${getThreeDigits(state.page)}.json`

    // Retrieve the file.
    const src = window.__path ? `/${window.__path}/${st ? 'states' : 'directory'}/${filename}` : `/${st ? 'states' : 'directory'}/${filename}`

    fetch(src)
      .then(response => response.json())
      .then(data => {
        const cities = data.cities.reduce( (obj, city) => {
          if(!obj[city.state]) {
            obj[city.state] = []
          }
          obj[city.state].push(city)
          return obj
        }, {})
        setState( prevState => ({
          ...prevState,
          page: data.page,
          perPage: data.perPage,
          totalCount: data.totalCities,
          cities: cities,
        }))
        scrollToTop()
      })
  }, [state.page])

  const handleCityClick = (e, location) => {
    localStorage.setItem('geoInfo', JSON.stringify({
      location: location,
      city: location.split(', ')[0],
      region_code: location.split(', ')[1],
    }))

    setSite({
      ...site,
      location: location,
    })

    // scrollToTop()
  }

  const handlePageUpdate = page => {
    setState({
      ...state,
      page: page,
    })
  }

  const handleStateFilter = state => {
    if(state === 'all'){
      window.location.href = `${window.location.origin}/${site.path ? `${site.path}/directory` : 'directory'}`
    } else {
      window.location.href = `${window.location.origin}/${site.path ? `${site.path}/directory/${state.toLowerCase()}` : `directory/${state.toLowerCase()}`}`
    }
  }

  return (
    <div className="directory-content-container">
      <div className="container">
        <h2>Directory</h2>
        <div className="state-selector-container">
          <Select
            placeholder="Filter by state..."
            onChange={ location => handleStateFilter(location) }
            options={[
              {
                label: 'All States',
                value: 'all',
              },
              ...STATES_OPTIONS
            ]} />
        </div>
        <ul>
          {
            Object.entries(state.cities).map( (key, i) => <React.Fragment key={i}>
              <li key={key[0]} className="state-label"><h3>{key[0]}</h3></li>
              {state.cities[key[0]].map( city => <li key={city.name}><NavLink to={`/${city.state.toLowerCase()}/${city.name.toLowerCase()}`} onClick={ e => handleCityClick(e, `${city.name}, ${city.state.toUpperCase()}`) }>{city.name}</NavLink></li> )}
            </React.Fragment>)
          }
        </ul>
        <Pagination
          page={state.page}
          perPage={state.perPage}
          resultsCount={state.totalCount}
          updatePage={ page => handlePageUpdate(page)} />
      </div>
    </div>
  )
}

export default DirectoryContent
